import { replace } from "infrastructure/router";
import type { ResourceResponse } from "types";
import { WebRoutes } from "consts/enpoints/web";
import { AUTH_DATA_KEY } from "consts/general";
import { ResponseCode } from "consts/api";
import { RoleName } from "consts/auth";
import Storage from "util/storage";
import decodeToken from "util/jwt";
import type { AuthData, AuthUserPayload } from "features/auth/types";

export const getAuthData = () =>
    Storage.getItem<AuthData>(AUTH_DATA_KEY);

export const getAuthToken = () =>
    getAuthData()?.access_token;

export const getTokenPayload = () => {
    const token = getAuthToken();

    if (!token) {
        return;
    }

    return decodeToken(token) as AuthUserPayload;
};

export const getUserId = () => getTokenPayload()?.userId;

export const getRoleName = () =>
    getAuthData()?.role_name;

export const setAuthData = (authData: AuthData) => {
    Storage.setItem(AUTH_DATA_KEY, authData);
};

export const revokeAuthData = () => {
    Storage.removeItem(AUTH_DATA_KEY);
};

export const isCodeIncludes = (code: number) =>
    [ResponseCode.Unathenticated].includes(code);

export const isResponseValid = (response: ResourceResponse<unknown>) =>
    !isCodeIncludes(response?.code);

export const isEmployee = (roleName: string) =>
    Object.is(roleName, RoleName.MerchantEmployee);

export const isMerchant = (_: string) => true;

export const isAdmin = (roleName: string) => [
    RoleName.MerchantAdmin,
].includes(roleName as RoleName);

export const withLoader = (api: (params: AuthUserPayload & AuthData) => Promise<Response>) =>
    async () => {
        const [
            userPayload,
            authData
        ] = [
            getTokenPayload(),
            getAuthData()
        ];

        if (!authData || !userPayload) {
            return replace(WebRoutes.Login.Index);
        }

        const response = await api({
            ...userPayload,
            ...authData
        });

        return response.json();
    };
